import { useMsal } from '@azure/msal-react';
import { parse } from 'qs';
/** Get user's credentials (sid or login_hint/username) either from MSAL instance or from url params */
export const useParamsToGetUserId = () => {
    var _a, _b;
    const { instance } = useMsal();
    const params = parse(window.location.search, { ignoreQueryPrefix: true });
    const sid = params.sid || ((_a = instance.getActiveAccount()) === null || _a === void 0 ? void 0 : _a.localAccountId);
    const loginHint = params.login_hint ||
        params.loginHint ||
        params.username ||
        ((_b = instance.getActiveAccount()) === null || _b === void 0 ? void 0 : _b.username);
    if (!sid && !loginHint) {
        return {};
    }
    return { sid, loginHint };
};
